import { Col, Row } from "react-bootstrap";
import DropDownItem from "../DropDownComponent/DropDown";
import visitorTypes from "../../constants/contentFile.json";

const ReportCategory = ({ selectedItem, setSelectedItem, list }) => {
  return (
    <>
      {console.log("Sel", selectedItem)}
      <DropDownItem
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        categoryRequired={false}
        list={[{ id: 0, name: "All" }, ...list]}
      />
    </>
  );
};

export default ReportCategory;
